import { render, staticRenderFns } from "./masterList.vue?vue&type=template&id=f29af5f8&"
import script from "./masterList.vue?vue&type=script&lang=js&"
export * from "./masterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports